import angular from 'angular';
import { StripeFactory } from './factory.stripe';
import { StripeService } from './service.tn.stripe';

export default angular
    .module('tn.stripe', ['tn.django', 'tn.user'])
    // providers
    .factory('Stripe', StripeFactory)
    .service('tn.stripe.service', StripeService).name;
